import { SystemUsageData } from "../../../../../types"
import { numberToUSD } from "../../../../utils"
import Cell from "../../../billing-table/cell"
import HeaderCell from "../../../billing-table/header-cell"
import HeaderRow from "../../../billing-table/header-row"
import If from "../../../if"
import TableFooter from "../table-footer"
import TableWrapper from "../table-wrapper"

interface Props {
  usage: SystemUsageData
}

const SMSBreakdown = ({ usage }: Props) => (
  <If
    condition={!!usage?.breakdown?.cost?.breakdown?.sms?.breakdown[0]?.subtotal}
    then={
      <>
        <div>
          <strong>Total SMS Threads:</strong> {usage?.breakdown.sms.total} (
          {usage?.pricing_details.included_sms_threads} included)
        </div>

        <TableWrapper>
          <thead>
            <HeaderRow>
              <HeaderCell>LINE ITEM</HeaderCell>
              <HeaderCell className="text-center">RATE</HeaderCell>
              <HeaderCell className="text-center">COUNT</HeaderCell>
              <HeaderCell className="text-right">LINE TOTAL</HeaderCell>
            </HeaderRow>
          </thead>
          <tbody className="divide-y divide-zinc-200">
            {usage?.breakdown?.cost?.breakdown?.sms?.breakdown?.map(
              (item, key) =>
                item.subtotal && (
                  <tr key={key}>
                    <Cell>
                      <span>Tier {key + 1} SMS</span>
                      <br />
                      <small>
                        SMS count {item.start}{" "}
                        {item.stop ? `- ${item.stop}` : "+"}
                      </small>
                    </Cell>
                    <Cell className="text-center">{numberToUSD(item.cpt)}</Cell>
                    <Cell className="text-center">
                      {Math.round(item.subtotal / item.cpt)}
                    </Cell>
                    <Cell className="text-right">
                      {numberToUSD(item.subtotal)}
                    </Cell>
                  </tr>
                )
            )}

            <tr>
              <Cell>Base Fee</Cell>
              <Cell className="text-center">
                {numberToUSD(usage?.breakdown?.cost?.breakdown?.sms?.base_fee)}
              </Cell>
              <Cell className="text-center"> </Cell>
              <Cell className="text-right">
                {numberToUSD(usage?.breakdown?.cost?.breakdown?.sms?.base_fee)}
              </Cell>
            </tr>
          </tbody>

          <TableFooter
            subTotal={usage?.breakdown?.cost?.breakdown?.sms?.total ?? 0}
          />
        </TableWrapper>
      </>
    }
  />
)

export default SMSBreakdown
